import React from 'react'
import { selectThemeStyle } from '../../../../features/setting/setting.slice.ts'
import { useAppSelector } from '../../../../redux/hooks.ts'
import Dropdown from 'antd/es/dropdown'
import {
  CaretDownOutlined,
  SketchOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { UserMenu } from './user-menu.tsx'
import Typography from 'antd/es/typography'
import { MenuProps } from 'antd/es/menu/menu'
import { selectUser } from '../../../../features/user/user.slice.ts'

interface UserDropdownProps {
  fullName: string
}

export const UserDropdown: React.FC<UserDropdownProps> = ({ fullName }) => {
  const themeStyle = useAppSelector(selectThemeStyle)
  const items: MenuProps['items'] = []
  const userInfo = useAppSelector(selectUser)
  const isInternalUser = userInfo.role !== ''

  // Responsive: adjust width for mobile
  const [dropdownWidth, setDropdownWidth] = React.useState(
    window.innerWidth < 400 ? '90vw' : '280px'
  )
  React.useEffect(() => {
    const handleResize = () =>
      setDropdownWidth(window.innerWidth < 400 ? '90vw' : '280px')
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <Dropdown
      menu={{ items }}
      dropdownRender={() => (
        <div
          style={{
            borderRadius: themeStyle.borderRadiusLG,
            backgroundColor: themeStyle.contentBg,
            width: dropdownWidth,
            boxShadow:
              '0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 9px 28px 8px rgba(0, 0, 0, 0.05)',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: `${themeStyle.paddingBase}, ${themeStyle.paddingContentHorizontalLG}`,
            gap: themeStyle.marginBase,
          }}
        >
          <UserMenu />
        </div>
      )}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          cursor: 'pointer',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            backgroundColor: themeStyle.contentBg,
            border: `1px solid ${isInternalUser ? themeStyle.colorPrimaryBorderGold : themeStyle.colorPrimaryBorder}`,
          }}
        >
          {isInternalUser ? <SketchOutlined /> : <UserOutlined />}
        </div>
        <Typography.Text style={{ color: themeStyle.naviText, margin: 0 }}>
          {fullName}
        </Typography.Text>
        <CaretDownOutlined />
      </div>
    </Dropdown>
  )
}
